import React from 'react';

import { ROUTE } from 'constants/routes';

// Auth

const LoginPage = React.lazy(() => import('pages/auth/login'));
const ForgotPasswordPage = React.lazy(
  () => import('pages/auth/forgot-password')
);

// Service
const PrivacyPolicyPage = React.lazy(() => import('pages/privacy-policy'));
const TermsOfServicePage = React.lazy(() => import('pages/terms-of-service'));

// Dashboard
const Users = React.lazy(() => import('pages/users'));
const Admins = React.lazy(() => import('pages/admins'));
const Recipes = React.lazy(() => import('pages/recipes'));
const Reviews = React.lazy(() => import('pages/reviews'));
const Settings = React.lazy(() => import('pages/settings'));
const Dashboard = React.lazy(() => import('pages/dashboard'));

export const AdminRoutes = [
  { path: ROUTE.Dashboard.path, element: <Dashboard /> },
  { path: ROUTE.Recipes.path, element: <Recipes /> },
  { path: ROUTE.Admins.path, element: <Admins /> },
  { path: ROUTE.Users.path, element: <Users /> },
  { path: ROUTE.Reviews.path, element: <Reviews /> },
  { path: ROUTE.Settings.path, element: <Settings /> },
];

export const AuthRoutes = [
  { path: ROUTE.Login.path, element: <LoginPage /> },
  { path: ROUTE.ForgotPassword.path, element: <ForgotPasswordPage /> },
];

export const ServiceRoutes = [
  { path: ROUTE.PrivacyPolicy.path, element: <PrivacyPolicyPage /> },
  { path: ROUTE.TermsOfService.path, element: <TermsOfServicePage /> },
];
